export const INIT_STACKUP_DATA = 'init_stackup_data';
export const CHANGE_STACKUP_TABLE = 'change_stackup_table';
export const SETTING_UNIT = 'setting_unit';